import React, { useState, useEffect, Suspense } from "react";
import AdminRouter from "./AdminRouter";
import PublicRouter from "./PublicRouter";
import checkAuth from "../app/auth";
import SeoRouter from "./SeoRouter";
import MenagerRouter from "./MenagerRouter";
import SupportRouter from "./SupportRouter";
import BusinessAnalystRouter from "./BusinessAnalystRouter";

const AllRouters = () => {
  const [isAuthenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const authenticateUser = async () => {
      try {
        const tokens = await checkAuth(); // Assuming checkAuth returns a promise
        if (tokens) {
          setAuthenticated(true);
        }
      } catch (error) {
        console.error("Error authenticating user:", error);
        setAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };

    authenticateUser();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }
  const userType = JSON.parse(localStorage.getItem('user'));
  // console.log("userType?.user_type", userType?.user_type)

  return (
    <Suspense fallback={<div>Loading...</div>}>
      {isAuthenticated ? (
        userType?.user_type ? (
          (() => {
            switch (userType.user_type) {
              case 'SUPERADMIN':
                return <AdminRouter />;
              case 'SEO':
                return <SeoRouter />;
              case 'MANAGER':
                return <MenagerRouter />;
              case 'SUPPORT':
                return <SupportRouter />;
              case 'BUSINESS_ANALYST':
                return <BusinessAnalystRouter />;
              default:
                console.warn(`Unknown user type: ${userType.user_type}`);
                return <PublicRouter />;
            }
          })()
        ) : (
          <div>Loading user type...</div>
        )
      ) : (
        <PublicRouter />
      )}
    </Suspense>



  );
};

export default AllRouters;
